import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

export const PickProgramSectionMobileRightLightEggBg = styled.img`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    display: inline;
    position: absolute;
    z-index: 0;
    right: -100px;
    top: -100px;
  }
`;

export const PickProgramSectionWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1120px;
  margin: auto;
  position: relative;
  z-index: 1;

  @media (max-width: ${TabletWidth}px) {
    max-width: 100%;
    margin-bottom: 0px;
    padding: 0px 24px;
  }
`;

export const PickProgramSectionTitle = styled.div`
  text-align: center;
  font-family: Lora;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  color: ${getColor('GRAY_70')};
  z-index: 1;
  max-width: 600px;
  margin-bottom: 56px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 24px;
    line-height: 130%;
    font-size: 26px;
    max-width: 290px;
    margin-bottom: 46px;
  }
`;

export const PickProgramSectionSubtitle = styled.div`
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  color: ${getColor('GRAY_70')};
  z-index: 1;
  max-width: 520px;
  margin-bottom: 66px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 16px;
    line-height: 24px;
    max-width: 290px;
    margin-bottom: 50px;
  }
`;

export const PickProgramSectionContent = styled.div`
  width: 100%;
  z-index: 1;
`;

export const PickProgramSectionProducts = styled.div`
  margin-bottom: 55px;
  display: flex;
  justify-content: center;
`;
